<template>
  <div class="ractice">
    <div class="header">
      <div class="title">执业申请资格条件</div>
    </div>
    <div>
      <div
        class="item_apply"
        style="border-bottom: 1px #ededed solid; padding: 15px 0"
      >
        <div class="realImg">
          <img
            style="width: 12px; height: 12px"
            :src="'https://payment-writemall-com.oss-cn-shenzhen.aliyuncs.com/miniapps/wqzk/resume_title.png'"
            mode=""
          />
          <div class="name_apply">实名认证</div>
        </div>
        <div
          class="realImg"
          style="cursor: pointer"
          @click="goRealName()"
          v-if="!userData.authenticationStatus"
        >
          请完成实名认证
          <i class="el-icon-arrow-right"></i>
        </div>
        <div
          class="realImg"
          @click="goRealName(true)"
          style="color: #999; font-size: 13px; cursor: pointer"
          v-else
        >
          <img
            style="
              width: 17px;
              height: 17px;
              margin-top: 2px;
              margin-right: 3px;
            "
            :src="'https://payment-writemall-com.oss-cn-shenzhen.aliyuncs.com/miniapps/wqzk/certificationPage_renz1.png'"
            mode=""
          />
          实名认证已完成
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="item_apply" style="padding: 15px 0">
        <div class="realImg">
          <img
            style="width: 12px; height: 12px"
            :src="'https://payment-writemall-com.oss-cn-shenzhen.aliyuncs.com/miniapps/wqzk/resume_title.png'"
            mode=""
          />
          <div class="name_apply">个人简历</div>
        </div>
        <div
          @click="ediResume(userData.resume)"
          class="realImg"
          :style="{
            color: userData.resume ? '#999' : '#326AFB',
            fontSize: userData.resume ? '13px' : '15px',
            cursor: 'pointer',
          }"
        >
          {{ !userData.resume ? '请添加个人简历' : '查看/修改个人简历' }}
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
    <div class="header" style="margin: 10px 0">
      <div class="title">现有执业资格</div>
    </div>
    <div class="list" v-show="seniorityList.length != 0" @scroll="scrollTask">
      <div
        style="border-bottom: 1px #ededed solid; padding: 10px 0 10px"
        v-for="(el, i) in seniorityList"
        :key="i"
        @click="divPracticeInformation(el.typeId)"
      >
        <div class="item_apply_box" style="padding-bottom: 10px">
          <div class="">
            <div
              class=""
              style="
                width: 75px;
                height: 75px;
                border-radius: 10px;
                overflow: hidden;
                margin-right: 20px;
              "
            >
              <img
                style="width: 100%; height: 100%"
                :src="imgUrl + 'wq_service.png'"
                mode=""
              />
            </div>
            <div class="practice_name">
              <div class="">{{ el.typeName }}</div>
              <div class="time_box">
                {{ el.practiceLocation }}
              </div>
              <div class="time_box">{{ el.createTime }}</div>
            </div>
          </div>
          <div style="margin-right: 10px">
            <img
              style="width: 14px; height: 14px"
              :src="imgUrl + 'settingsPage_arrow.png'"
              mode=""
            />
          </div>
        </div>
        <div
          class="service_box"
          @click.stop="
            isPractice = false
            servicesProductList(el.typeId)
          "
        >
          专业服务管理
        </div>
      </div>
    </div>

    <div class="empty" v-show="seniorityList.length == 0">
      <img :src="require('assets/images/kong.png')" alt="" />
      <div>暂无任务</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['userData', 'seniorityList'],
  data() {
    return {
      imgUrl:
        'https://payment-writemall-com.oss-cn-shenzhen.aliyuncs.com/miniapps/wqzk/',
    }
  },
  methods: {
    goRealName(v) {
      this.$emit('goRealName', v)
    },
    scrollTask(e) {
      this.$emit('scrollTask', e)
    },
    servicesProductList(v) {
      this.$emit('servicesProductList', v)
    },
    divPracticeInformation(v) {
      this.$emit('divPracticeInformation', v)
    },

    ediResume(v) {
      this.$emit('ediResume', v)
    },
  },
}
</script>

<style lang="scss" scoped>
.ractice {
  height: 640px;

  border-radius: 10px;
  .food_content {
    max-height: 520px;
    overflow-y: auto;
    padding: 30px 80px 20px 20px;
    box-sizing: border-box;
    .loadbox {
      height: 30px;
      color: #666;
      font-size: 12px;
    }
    .foo_btn {
      cursor: pointer;
      width: 200px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      background-color: #4587ff;
      border-radius: 4px;
      margin: 60px auto 0;
      color: #fff;
    }
  }
  .food_contents {
    max-height: 520px;
    overflow-y: auto;
    .kong {
      font-size: 13px;
      margin: 100px 0;
      color: #333;
      text-align: center;
      img {
        width: 100px;
      }
    }
    .select_box {
      width: 100%;
      min-height: 50px;
      background: #f7f8fa;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      // justify-content: space-between;
      padding: 15px;
      // align-items: center;
      box-sizing: border-box;
      margin-bottom: 10px;

      > div:first-child {
        font-weight: 600;
        font-size: 17px;
        color: #000;
      }

      .center_box {
        font-size: 15px;
        color: #666666;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 14px 0;

        .sanchu {
          display: flex;
          align-items: center;
          cursor: pointer;
          img {
            width: 16px;
            height: 16px;
            margin-right: 5px;
          }
        }
      }

      .shuxian {
        width: 3px;
        height: 17px;
        background-color: #b5b5b5;
        margin: 0 10px;
      }
    }
    .foo_btns {
      cursor: pointer;
      width: 200px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      background-color: #fff;
      border: 1px solid #326afb;
      border-radius: 4px;
      margin: 60px auto 0;
      color: #326afb;
    }
  }
  .item_apply {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .realImg {
      font-size: 13px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      img {
        margin-right: 10px;
      }
    }
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 30px;
    .tit_box {
      font-size: 16px;
      font-weight: bold;
      color: #000000;

      display: flex;
      align-items: center;
      justify-content: space-between;
      .tip {
        font-size: 12px;
        font-weight: normal;
        color: #333;
        > text {
          color: #326afb;
        }
      }
    }
    .title {
      position: relative;
      font-size: 16px;
      width: 100%;
      font-family: Microsoft YaHei;
      font-weight: 600;
      color: #333333;
      .el-button {
        position: absolute;
        top: -10px;
        right: 0;
      }
    }
    .more {
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      cursor: pointer;
    }
  }
  .content_list {
    height: calc(100% - 30px) !important;
  }
  .list {
    height: calc(100% - 140px);
    overflow: auto;
    .content_box {
      width: 100%;
      min-height: 150px;
      border-radius: 10px 10px 0 0;
      background-color: #fff;
      padding: 10px 23px calc(env(safe-area-inset-bottom) + 110px);
      box-sizing: border-box;
    }
    .list-item {
      display: flex;
      cursor: pointer;
      flex-direction: column;
      gap: 15px;
      margin-bottom: 20px;
      border-bottom: 1px solid #f7f7f7;
      padding: 10px 0;
      .top {
        display: flex;
        align-items: center;
        .index {
          width: 24px;
          height: 24px;
          margin-right: 10px;
          background: #f2f6ff;
          border-radius: 50%;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #326afb;
          // line-height: 15px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .title {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #222222;
          flex: 1;
        }
        .accept {
          width: 79px;
          height: 28px;
          background: #f4f7ff;
          border-radius: 5px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #326afb;
          line-height: 28px;
          padding-left: 20px;
          box-sizing: border-box;
          cursor: pointer;
          position: relative;
          &::after {
            content: '';
            position: absolute;
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background: #326afb;
            top: 50%;
            transform: translateY(-50%);
            left: 8px;
          }
        }
      }
      .center {
        display: flex;
        align-items: center;
        .type,
        .region {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
        }
        .region {
          margin-left: 10px;
        }
        .demand {
          margin-left: 20px;
          flex: 1;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 15px;
          // text-align: center;
        }
        .price {
          .unit {
            font-size: 12px;
          }
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ff5346;
          line-height: 15px;
        }
      }
      .bottom {
        .createTime {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
        }
      }
    }
  }
  .empty {
    text-align: center;
    margin: 25% 0;
    img {
      width: 150px;
      height: 150px;
    }
    font-size: 14px;
    color: #999;
    text-align: center;
  }
  .service_box {
    padding: 4px 0;
    font-size: 14px;
    color: #326afb;
    text-align: right;
    font-weight: bold;
    cursor: pointer;
  }
  .item_apply_box {
    width: 100%;
    padding: 5px 0;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;

    > div:first-child {
      display: flex;
      align-items: center;

      .name_apply {
        font-weight: 600;
        font-size: 15px;
      }

      > img {
        margin-right: 15px;
      }
    }

    .practice_name_box {
      display: flex;
      align-items: center;
      > div:first-child {
        font-weight: 600;
        font-size: 15px;
        color: #222222;
      }

      .time_box {
        font-size: 13px;
        color: #999999;
        margin-top: 10px;
      }
      > span {
        display: block;
        font-size: 15px;
        font-weight: bold;
        color: #326afb;
        width: 21px;
        height: 21px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f2f6ff;
        border-radius: 50%;
      }
    }
    .apply_label {
      cursor: pointer;
      padding: 4px 6px;
      border-radius: 3px;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    .pass_color {
      background: #f4f7ff;
      color: #326afb;
    }

    .no_rediv {
      color: #f84140;
      background: #ffefef;
    }

    .examine_color {
      color: #00be59;
      background: #e7f9f0;
    }

    .practice_name {
      > div:first-child {
        font-weight: 600;
        font-size: 15px;
        color: #222222;
      }

      .time_box {
        font-size: 13px;
        color: #999999;
        margin-top: 10px;
      }
    }
  }
}
</style>
